import { useEffect } from 'react';

export const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 py-16" data-testid="cookie-policy-page">
      <h1 className="font-heading text-4xl mb-8">Cookie Policy</h1>
      <p className="text-gray-500 text-sm mb-8">Last Updated: March 14, 2026</p>
      
      <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
        <section>
          <h2 className="font-heading text-2xl mb-4">What Are Cookies?</h2>
          <p>
            Cookies are small text files that are stored on your computer or mobile device when you visit our website. They help us provide you with a better experience by remembering your preferences and understanding how you use our site.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Types of Cookies We Use</h2>
          
          <h3 className="font-semibold text-lg mt-4 mb-2">Essential Cookies</h3>
          <p>
            These cookies are necessary for the website to function properly. They enable core functionality such as security, network management, and accessibility.
          </p>
          
          <h3 className="font-semibold text-lg mt-4 mb-2">Performance Cookies</h3>
          <p>
            These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.
          </p>
          
          <h3 className="font-semibold text-lg mt-4 mb-2">Functional Cookies</h3>
          <p>
            These cookies enable enhanced functionality and personalization, such as remembering your login details and language preferences.
          </p>
          
          <h3 className="font-semibold text-lg mt-4 mb-2">Marketing Cookies</h3>
          <p>
            These cookies may be set through our site by advertising partners to build a profile of your interests and show you relevant ads on other sites.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Cookies We Use</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2 text-left border-b">Cookie Name</th>
                  <th className="px-4 py-2 text-left border-b">Purpose</th>
                  <th className="px-4 py-2 text-left border-b">Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-2 border-b">auth_token</td>
                  <td className="px-4 py-2 border-b">User authentication</td>
                  <td className="px-4 py-2 border-b">24 hours</td>
                </tr>
                <tr>
                  <td className="px-4 py-2 border-b">language_preference</td>
                  <td className="px-4 py-2 border-b">Language selection</td>
                  <td className="px-4 py-2 border-b">1 year</td>
                </tr>
                <tr>
                  <td className="px-4 py-2 border-b">cookie_consent</td>
                  <td className="px-4 py-2 border-b">Cookie preferences</td>
                  <td className="px-4 py-2 border-b">1 year</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Managing Cookies</h2>
          <p>
            You can control and manage cookies in several ways:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Browser Settings:</strong> Most browsers allow you to refuse or accept cookies, delete existing cookies, and set preferences for certain websites.</li>
            <li><strong>Opt-Out Links:</strong> Many advertising networks provide opt-out mechanisms.</li>
          </ul>
          <p className="mt-4">
            Note: Blocking certain cookies may impact your experience on our website.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Third-Party Cookies</h2>
          <p>
            Some cookies are placed by third-party services that appear on our pages. We do not control these cookies. Third parties may include analytics providers and advertising networks.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Changes to This Policy</h2>
          <p>
            We may update this Cookie Policy from time to time. Changes will be posted on this page with an updated revision date.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Contact Us</h2>
          <p>If you have questions about our use of cookies:</p>
          <ul className="list-none space-y-2 mt-4">
            <li><strong>Email:</strong> jaxremodelingsolutions@gmail.com</li>
            <li><strong>Phone:</strong> (904) 863-6673</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default CookiePolicy;
